import * as React from "react";
import {ReactElement} from "react";
import {getText} from "../../services/configuration.service";

export enum ErrorCode {
    MAX_PAX_NUMBER = "MAX_NUMBER",
    MIN_PAX_NUMBER = "MIN_NUMBER"
}

export interface ErrorMessageProps {
    errorCode: string;
    minPax?: number;
    maxPax?: number;
    addClass?: string;
}

/**
 * ErrorMessage
 * @param errorCode
 * @param minPax
 * @param maxPax
 * @param addClass
 * @constructor
 */
const ErrorMessage = ({errorCode, minPax = 1, maxPax = 9, addClass = ""}: ErrorMessageProps): ReactElement => {
    let message = "";
    const displayClass = errorCode !== "" ? "" : "d-none";
    if (errorCode === ErrorCode.MAX_PAX_NUMBER) {
        message = getText("booking.passenger.error.maxpax") + maxPax;
    } else if (errorCode === ErrorCode.MIN_PAX_NUMBER) {
        message = getText("booking.passenger.error.minpax") + minPax;
    }
    return (
        <div className={`cpt-error-message ${displayClass} ${addClass}`}>
            {message}
        </div>
    );
};

export default ErrorMessage;
